import React, { useState } from "react";
import './ModalFusion.scss';
import imgFusionSuccess from 'static/fusion-success.png';
import light from 'static/light.png'
import imgAnnoucement from 'static/drop-money-announcement.png';
import icClose from 'static/ic-close-bg.png';
import bgRem from 'static/bg-money-announcement.png';
import icFlicker from "static/ic-flicker-light.png";
import { firework } from 'helpers/animation';
import styled from "styled-components";
import { numberFormat } from "helpers/helpers";
import { getHistoryFilter } from "services";
import { connect } from "react-redux";
import { HISTORY_LIST_AFTER_FUSION, PRIZE_TYPE } from "helpers/constants";

const Background = styled.img`
    position: absolute;
    width: 100vw;
    height: 100vh;
`

const FlickerBottom = styled.img`
    position: absolute;
    top: 6.5rem;
    left: 1.25rem;
    zoom: 2;
    mix-blend-mode: hard-light;
`

const FlickerTop = styled.img`
    position: absolute;
    top: 2.125rem;
    right: 2.125rem;
    zoom: 2;
    mix-blend-mode: hard-light;
`
const AnnouncementTitle = styled.p`
    position: absolute;
    top: 147.27px;
    right:0;
    left:0;
    margin-right: auto;
    margin-left: auto;
    text-align:center;
    color: rgba(204, 0, 0, 1);
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.875rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
`
const Announcement = styled.p`
    width: 449.08px;
    height: 45.52px;
    position: absolute;
    top: 187.5px;
    right:0;
    left:0;
    margin-right: auto;
    margin-left: auto;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1rem;
    letter-spacing: 0.1em;
    text-align:center;
    color: rgba(78, 0, 0, 1);
`

const Overlay = styled.div`
    width: 100vw;
    height: 100vh;
    position: absolute;
    z-index: 9999;
    background-color: rgb(8 16 97 / 40%);
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
`

const Loading = styled.div`
    position: absolute;
    float: none;
    background: transparent;
    padding-top: 40vh;
    z-index: 99999;
`

const Spinner = styled.div`
    border: 3px solid red;
    border-right-color: transparent;
`

const ModalFusion = ({ isOpen, onCloseModal, gameCode, data, getHistoryFilter }) => {
    const handleCloseAnnouncement = async () => {
        setLoading(true);
        const result = await getHistoryFilter({ gameCode: gameCode, prizeType: PRIZE_TYPE.MAGIC });
        const magicHistory = result && result.historyList ? result.historyList.filter(item => item.serviceResCd === "") : [];
        setLoading(false);
        onCloseModal(magicHistory);
    }
    const [openAnnouncement, setAnnouncement] = useState(false);
    const [loading, setLoading] = useState(false);
    isOpen && !openAnnouncement && firework();
    return (
        <>
            <div className={`relative z-[99999] ${isOpen && openAnnouncement ? "" : "hidden"}`}>
                <Background src={bgRem} />
                <div className="d-flex justify-content-between">
                    <img className="light light-left" src={light} />
                    <img className="light light-right" src={light} />
                </div>

                <div className="announcement">
                    <div className="relative">
                        <img className="ic-close icon-header" src={icClose} onClick={() => handleCloseAnnouncement()} />
                        <img src={imgAnnoucement} />
                        <FlickerBottom className="animate-flicker" src={icFlicker} />
                        <FlickerTop className="animate-flicker" src={icFlicker} />
                        <AnnouncementTitle>Tiền mặt: {numberFormat(data.rewardMoney, ",")} VND</AnnouncementTitle>
                        <Announcement>{data.message}</Announcement>
                    </div>
                </div>
            </div>

            <div className={`${isOpen && !openAnnouncement ? "" : "hidden"}`}>
                <Overlay className="overlay-test" />
                <div className="container z-[99999] p-0 d-flex align-items-center">
                    <img className={`${isOpen && !openAnnouncement && "fusion-success"}`} src={imgFusionSuccess} />
                    <p onClick={() => setAnnouncement(true)}
                        className="linear-button text-center absolute bottom-[2.5%]"
                        style={{ margin: "0 auto 1.8rem auto", minWidth: "6.9475rem" }}>Đóng</p>
                </div>
            </div>
            {loading && <Loading className="overlay">
                <Spinner className="spinner" />
            </Loading>}
        </>
    );
}

const mapDispatchToProps = dispatch => ({
    getHistoryFilter: (params) => dispatch(getHistoryFilter(params)),
});


export default connect(null, mapDispatchToProps)(ModalFusion);